// Be Bold - Year 1 Programme Data
// 52 weeks: Foundation (1-12), Intermediate (13-32), Advanced (33-52)
// Deload weeks: 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48
// pushRules: 'direction_max_5s' | 'wave_4s_per_level' | null (max 8s)

export const YEAR1_WEEKS = [

  // -- FOUNDATION -----------------------------------------------

  {
    week: 1,
    theme: 'Meeting Your Floor',
    theme_pt: 'Conhecendo seu Assoalho',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#8B4A5A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 3, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 3, reps: 6 },
    milestone: null,
    appNote: 'This week is about noticing, not performing. If you feel nothing at first, that is your starting point.',
    appNote_pt: 'Esta semana e sobre perceber, nao performar. Se nao sentir nada no inicio, esse e o seu ponto de partida.',
  },

  {
    week: 2,
    theme: 'Lift and Let Go',
    theme_pt: 'Subir e Soltar',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#8B4A5A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 3, sets: 2, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 3, reps: 8 },
    milestone: null,
    appNote: 'Two beats: gentle lift in, then a full let-go out. The let-go is the part most women skip.',
    appNote_pt: 'Dois tempos: uma subida suave para dentro, depois solta completamente. Soltar e a parte que a maioria pula.',
  },

  {
    week: 3,
    theme: 'Finding Your Rhythm',
    theme_pt: 'Encontrando o Ritmo',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#8B4A5A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 5, sets: 3, reps: 10 },
    relax: { cycles: 8 },
    push: { hold: 5, reps: 8 },
    milestone: null,
    appNote: 'Lift for 5, soften for 5. Same time on each side. The softening matters as much as the lift.',
    appNote_pt: 'Sobe em 5, solta em 5. Mesmo tempo dos dois lados. Soltar importa tanto quanto subir.',
  },

  {
    week: 4,
    theme: 'A Gentler Week',
    theme_pt: 'Uma Semana Mais Leve',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 3, sets: 2, reps: 8 },
    relax: { cycles: 6 },
    push: { hold: 3, reps: 6 },
    milestone: null,
    appNote: 'Easing back this week. This is when your body actually learns the movement, not when you push hardest.',
    appNote_pt: 'Pegando mais leve esta semana. E aqui que o corpo aprende de verdade, nao quando voce forca o maximo.',
  },

  {
    week: 5,
    theme: 'Holding Longer',
    theme_pt: 'Sustentando Mais Tempo',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#8B4A5A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 7, sets: 3, reps: 8 },
    relax: { cycles: 10 },
    push: { hold: 7, reps: 8 },
    milestone: null,
    appNote: 'A few seconds longer this week. The let-go between still matters more than the lift.',
    appNote_pt: 'Uns segundos a mais esta semana. Soltar entre uma e outra ainda importa mais que apertar.',
    pathBNote: 'Path B: gentle squeeze starts this week. Stay at about 20 percent. Pain-free only.',
    pathBNote_pt: 'Caminho B: apertos suaves comecam esta semana. Fique em uns 20 por cento. Somente sem dor.',
  },

  {
    week: 6,
    theme: 'Riding Your Breath',
    theme_pt: 'Junto com a Respiracao',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 4, color: '#8B4A5A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 8, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 10 },
    milestone: null,
    appNote: 'Let the breath come first. The squeeze just follows along.',
    appNote_pt: 'A respiracao vem primeiro. O aperto so segue junto.',
  },

  {
    week: 7,
    theme: 'Front, Then Back',
    theme_pt: 'A Frente, Depois o Fundo',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 4, color: '#8B4A5A',
    zone: 'Front and Back wall 0-3cm', zone_pt: 'Parede frontal e posterior 0-3cm',
    squeeze: { hold: 8, sets: 3, reps: 10 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    appNote: 'Squeeze the front, then squeeze the back. Two different feelings, both yours.',
    appNote_pt: 'Aperte na frente, depois no fundo. Duas sensacoes diferentes, as duas suas.',
    sessionOverride: { type: 'alt', altA: 'Front wall', altB: 'Back wall', altA_pt: 'Parede frontal', altB_pt: 'Parede posterior' },
  },

  {
    week: 8,
    theme: 'A Gentler Week',
    theme_pt: 'Uma Semana Mais Leve',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 5, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 5, reps: 6 },
    milestone: null,
    appNote: 'Easing back. The body learns more from the lighter weeks than from the harder ones.',
    appNote_pt: 'Pegando mais leve. O corpo aprende mais nas semanas leves do que nas mais pesadas.',
  },

  {
    week: 9,
    theme: 'The Sides Wake Up',
    theme_pt: 'Os Lados Acordam',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 4, color: '#8B4A5A',
    zone: 'Side walls 0-3cm', zone_pt: 'Paredes laterais 0-3cm',
    squeeze: { hold: 10, sets: 3, reps: 10 },
    relax: { cycles: 8 },
    push: { hold: 10, reps: 8 },
    milestone: null,
    appNote: 'This time, draw inward from the sides. Not upward. Like closing a soft purse.',
    appNote_pt: 'Desta vez, puxe para dentro pelos lados. Nao para cima. Como uma bolsinha que fecha.',
  },

  {
    week: 10,
    theme: 'Quick Squeezes',
    theme_pt: 'Apertos Rapidos',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: false,
    newMovement: 'Quick squeezes', newMovement_pt: 'Apertos rapidos',
    freq: 4, color: '#8B4A5A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 5, sets: 3, reps: 8 },
    relax: { cycles: 20 },
    push: { hold: 5, reps: 3 },
    milestone: null,
    appNote: 'New this week: quick squeezes. One second on, one second off. Each one is its own little squeeze, not a long hold cut in pieces.',
    appNote_pt: 'Novidade da semana: apertos rapidos. Um segundo apertando, um segundo solto. Cada um e um aperto inteirinho, nao um hold cortado em pedacos.',
    primaryExercise: 'pulsacao_entry',
    secondaryExercise: 'basic_hold',
  },

  {
    week: 11,
    theme: 'Quick and Slow Together',
    theme_pt: 'Rapido e Lento Juntos',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 4, color: '#8B4A5A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 10, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 10, reps: 8 },
    milestone: null,
    appNote: 'Quick squeezes first, then long ones. Soften completely between the fast sets, every time.',
    appNote_pt: 'Apertos rapidos primeiro, depois os longos. Solte por completo entre as series rapidas, sempre.',
  },

  {
    week: 12,
    theme: 'You Made the Floor',
    theme_pt: 'Voce Construiu o Assoalho',
    phase: 'Foundation', phase_pt: 'Fundacao',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 5, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 5, reps: 6 },
    milestone: {
      checks: [
        { en: 'Can you hold for 10 seconds without holding your breath or clenching your bottom?', pt: 'Consegue segurar 10 segundos sem prender a respiracao nem apertar o bumbum?' },
        { en: 'Do the quick squeezes feel clean: one on, one off, with nothing dragging?', pt: 'Os apertos rapidos saem limpinhos: um liga, um solta, sem nada arrastando?' },
        { en: 'Can you feel the difference between the front and the back?', pt: 'Voce sente a diferenca entre a frente e o fundo?' },
        { en: 'Can you push out gently without straining or bearing down?', pt: 'Consegue empurrar suave sem forcar ou empurrar para fora?' },
      ]
    },
  },

  // -- INTERMEDIATE A --------------------------------------------------

  {
    week: 13,
    theme: 'Central Zone Entry',
    theme_pt: 'Entrada na Zona Central',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 4, color: '#A07080',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 10, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 10, reps: 8 },
    milestone: null,
    appNote: 'All movements at Level 2 depth. Picture an elevator going one floor deeper.',
    appNote_pt: 'Todos os movimentos no Nivel 2. Imagine um elevador descendo um andar.',
  },

  {
    week: 14,
    theme: 'Aperto',
    theme_pt: 'Aperto',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false,
    newMovement: 'Aperto', newMovement_pt: 'Aperto',
    freq: 4, color: '#A07080',
    zone: 'Side walls 0-3cm', zone_pt: 'Paredes laterais 0-3cm',
    squeeze: { hold: 10, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 10, reps: 8 },
    milestone: null,
    appNote: 'NEW: Aperto. Press the side walls inward toward the centre. Horizontal, not upward.',
    appNote_pt: 'NOVO: Aperto. Pressione as paredes laterais em direcao ao centro. Horizontal, nao para cima.',
    primaryExercise: 'aperto_entry',
  },

  {
    week: 15,
    theme: 'Aperto at Depth',
    theme_pt: 'Aperto na Profundidade',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 4, color: '#A07080',
    zone: 'Side walls 3-6cm', zone_pt: 'Paredes laterais 3-6cm',
    squeeze: { hold: 12, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 12, reps: 8 },
    milestone: null,
    appNote: 'Aperto at Level 2. Press the side walls inward, hold the squeeze deep, then release fully.',
    appNote_pt: 'Aperto no Nivel 2. Pressione as paredes laterais para dentro, segure a contracao profunda e solte por completo.',
  },

  {
    week: 16,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Side walls 0-3cm', zone_pt: 'Paredes laterais 0-3cm',
    squeeze: { hold: 7, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 7, reps: 6 },
    milestone: null,
  },

  {
    week: 17,
    theme: 'Level by Level',
    theme_pt: 'Nivel por Nivel',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 4, color: '#A07080',
    zone: 'Full floor 0-6cm', zone_pt: 'Assoalho completo 0-6cm',
    squeeze: { hold: 12, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 12, reps: 8 },
    milestone: null,
    appNote: 'Layer Level 1, then add Level 2. Hold both. This is the prerequisite for Ordenha.',
    appNote_pt: 'Camada Nivel 1, depois adicione Nivel 2. Segure ambos. Pre-requisito para a Ordenha.',
  },

  {
    week: 18,
    theme: 'Ordenha',
    theme_pt: 'Ordenha',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false,
    newMovement: 'Ordenha', newMovement_pt: 'Ordenha',
    freq: 5, color: '#A07080',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 12, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 4, reps: 8 },
    pushRule: 'wave_4s_per_level',
    milestone: null,
    appNote: 'NEW: Ordenha ascending. Level 1 to Level 2 to Level 3. The PUSH IS the descending wave at 4 seconds per level.',
    appNote_pt: 'NOVO: Ordenha ascendente. Nivel 1 a Nivel 2 a Nivel 3. O EMPURRAR E a onda descendente a 4 segundos por nivel.',
    primaryExercise: 'ordenha_ascend',
    secondaryExercise: 'belly_breath_drop',
  },

  {
    week: 19,
    theme: 'Ordenha: Reaching Level 3',
    theme_pt: 'Ordenha: Alcancando o Nivel 3',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#A07080',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 12, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 4, reps: 8 },
    pushRule: 'wave_4s_per_level',
    milestone: null,
    appNote: 'Attempt Level 3. If not accessible, stay at Level 2. Do not force.',
    appNote_pt: 'Tente o Nivel 3. Se nao acessivel, fique no Nivel 2. Nao force.',
  },

  {
    week: 20,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 0-6cm', zone_pt: 'Assoalho completo 0-6cm',
    squeeze: { hold: 7, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 7, reps: 6 },
    milestone: null,
  },

  {
    week: 21,
    theme: 'Ordenha: Full Wave',
    theme_pt: 'Ordenha: Onda Completa',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#A07080',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 12, sets: 4, reps: 12 },
    relax: { cycles: 10 },
    push: { hold: 4, reps: 10 },
    pushRule: 'wave_4s_per_level',
    milestone: null,
    primaryExercise: 'ordenha_full',
    appNote: 'Ordenha ascends Level 1 to 3 and the PUSH carries the wave back down. Keep 4 seconds per level.',
    appNote_pt: 'A Ordenha sobe do Nivel 1 ao 3 e o PUSH leva a onda de volta para baixo. Mantenha 4 segundos por nivel.',
  },

  {
    week: 22,
    theme: 'Intermediate Check-In',
    theme_pt: 'Verificacao Intermediario A',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 4, color: '#A07080',
    zone: 'Full floor 0-6cm', zone_pt: 'Assoalho completo 0-6cm',
    squeeze: { hold: 10, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 10, reps: 8 },
    milestone: null,
    appNote: 'Session sequence: Pulsacao x20, Aperto x10, Ordenha ascending x8.',
    appNote_pt: 'Sequencia da sessao: Pulsacao x20, Aperto x10, Ordenha ascendente x8.',
  },

  // -- INTERMEDIATE B --------------------------------------------------

  {
    week: 23,
    theme: 'Ordenha at Speed',
    theme_pt: 'Ordenha em Velocidade',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#B08090',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 12, sets: 4, reps: 12 },
    relax: { cycles: 10 },
    push: { hold: 4, reps: 10 },
    pushRule: 'wave_4s_per_level',
    milestone: null,
    appNote: 'Full Ordenha cycle target: 4 seconds. Level separation must stay clear at speed.',
    appNote_pt: 'Meta do ciclo completo da Ordenha: 4 segundos. A separacao de niveis deve permanecer clara na velocidade.',
  },

  {
    week: 24,
    theme: 'Recovery: 8-Count Push Intro',
    theme_pt: 'Recuperacao: Introducao do Empurrar 8 Tempos',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 0-6cm', zone_pt: 'Assoalho completo 0-6cm',
    squeeze: { hold: 7, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null,
    appNote: 'NEW this week: 8-count PUSH. Contract fully, lower over 8 slow counts, then release completely.',
    appNote_pt: 'NOVO esta semana: EMPURRAR de 8 tempos. Contrair completamente, descer em 8 contagens lentas, soltar completamente.',
    eightCountPushIntro: true,
  },

  {
    week: 25,
    theme: 'Pulsacao at Level 2',
    theme_pt: 'Pulsacao no Nivel 2',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#B08090',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 12, sets: 5, reps: 30 },
    relax: { cycles: 8 },
    push: { hold: 12, reps: 3 },
    milestone: null,
    appNote: 'Pulsacao from Level 2. 1 second on, 1 second off, x30 reps x5 sets.',
    appNote_pt: 'Pulsacao do Nivel 2. 1 segundo ativado, 1 segundo solto, x30 rep x5 series.',
    primaryExercise: 'pulsacao_l2',
  },

  {
    week: 26,
    theme: 'Succao',
    theme_pt: 'Succao',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false,
    newMovement: 'Succao', newMovement_pt: 'Succao',
    freq: 5, color: '#9A7080',
    zone: 'Front wall 6-10cm', zone_pt: 'Parede frontal 6-10cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    appNote: 'NEW: Succao. Level 3 contraction and front wall draw-in. Maximum PUSH hold is 8 seconds.',
    appNote_pt: 'NOVO: Succao. Contracao Nivel 3 e succao da parede frontal. Hold maximo do EMPURRAR e 8 segundos.',
    primaryExercise: 'succao_entry',
  },

  {
    week: 27,
    theme: 'Succao: Holding at Depth',
    theme_pt: 'Succao na Profundidade',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#9A7080',
    zone: 'Front wall 6-10cm', zone_pt: 'Parede frontal 6-10cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    appNote: 'Succao at Level 3. Draw the front wall in and hold for 15 seconds. PUSH stays at 8 seconds.',
    appNote_pt: 'Succao no Nivel 3. Puxe a parede frontal para dentro e segure por 15 segundos. O PUSH fica em 8 segundos.',
  },

  {
    week: 28,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 8, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null,
  },

  {
    week: 29,
    theme: 'Onda',
    theme_pt: 'Onda',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false,
    newMovement: 'Onda', newMovement_pt: 'Onda',
    freq: 5, color: '#9A7080',
    zone: 'Full floor 0-6cm', zone_pt: 'Assoalho completo 0-6cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 5, reps: 8 },
    pushRule: 'direction_max_5s',
    milestone: null,
    appNote: 'NEW: Onda. Front wall for 2 seconds, release, back wall for 2 seconds. PUSH in the opposite direction.',
    appNote_pt: 'NOVO: Onda. Parede frontal por 2 segundos, soltar, parede posterior por 2 segundos. EMPURRAR na direcao oposta.',
    primaryExercise: 'onda_entry',
  },

  {
    week: 30,
    theme: 'Onda at Speed',
    theme_pt: 'Onda em Velocidade',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#9A7080',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 15, sets: 4, reps: 20 },
    relax: { cycles: 10 },
    push: { hold: 5, reps: 15 },
    pushRule: 'direction_max_5s',
    milestone: null,
    sessionOverride: { hold: 1, relax: 1, sets: 20 },
    appNote: 'Onda at 1 second per direction, 1 second release between, 20 sets.',
    appNote_pt: 'Onda a 1 segundo por direcao, 1 segundo de soltura entre, 20 series.',
  },

  {
    week: 31,
    theme: 'Onda and Aperto Combined',
    theme_pt: 'Onda e Aperto Combinados',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#9A7080',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 15, sets: 4, reps: 12 },
    relax: { cycles: 10 },
    push: { hold: 5, reps: 5 },
    milestone: null,
    appNote: 'Hold Aperto while doing Onda. Release all planes simultaneously.',
    appNote_pt: 'Mantenha o Aperto enquanto faz a Onda. Solte todos os planos simultaneamente.',
    exercises: ['aperto_hold', 'onda_entry'],
  },

  {
    week: 32,
    theme: 'Recovery: Intermediate Complete',
    theme_pt: 'Recuperacao: Intermediario Completo',
    phase: 'Intermediate', phase_pt: 'Intermediario',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 0-6cm', zone_pt: 'Assoalho completo 0-6cm',
    squeeze: { hold: 8, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Ordenha reaching Level 3 cleanly?', pt: 'Ordenha alcancando o Nivel 3 com limpeza?' },
        { en: 'Succao held for 15 seconds?', pt: 'Succao sustentada por 15 segundos?' },
        { en: 'Onda at 1 second per direction?', pt: 'Onda a 1 segundo por direcao?' },
        { en: 'Aperto and Onda combined in one set?', pt: 'Aperto e Onda combinados em uma serie?' },
      ]
    },
  },

  // -- ADVANCED --------------------------------------------------------

  {
    week: 33,
    theme: 'Deep Zone Endurance',
    theme_pt: 'Resistencia na Zona Profunda',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#7A5060',
    zone: 'Full floor 6-10cm', zone_pt: 'Assoalho completo 6-10cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    appNote: 'All movements at Level 3 depth.',
    appNote_pt: 'Todos os movimentos no Nivel 3.',
  },

  {
    week: 34,
    theme: '8-Count Push Mastery',
    theme_pt: 'Maestria do Empurrar 8 Tempos',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#7A5060',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 15, sets: 3, reps: 8 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 10 },
    milestone: null,
    appNote: 'The 8-count PUSH is the primary focus this week. Contract fully, lower over 8 slow counts, release completely.',
    appNote_pt: 'O EMPURRAR de 8 tempos e o foco principal esta semana. Contrair completamente, descer em 8 tempos lentos, soltar completamente.',
    primaryExercise: 'eight_count_push',
  },

  {
    week: 35,
    theme: 'Aperto at Full Depth',
    theme_pt: 'Aperto na Profundidade Total',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#7A5060',
    zone: 'Side walls 6-10cm', zone_pt: 'Paredes laterais 6-10cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    appNote: 'Aperto at Level 1, Level 2, and Level 3. All three levels in sequence.',
    appNote_pt: 'Aperto nos Niveis 1, 2 e 3. Os tres niveis em sequencia.',
  },

  {
    week: 36,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 8, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null,
  },

  {
    week: 37,
    theme: 'Vibracao',
    theme_pt: 'Vibracao',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false,
    newMovement: 'Vibracao', newMovement_pt: 'Vibracao',
    freq: 5, color: '#7A5060',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 12, sets: 4, reps: 20 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 3 },
    milestone: null,
    appNote: 'NEW: Vibracao. Pulsacao from Level 2. Target 2 to 3 reps per second.',
    appNote_pt: 'NOVO: Vibracao. Pulsacao do Nivel 2. Meta: 2 a 3 rep por segundo.',
    primaryExercise: 'vibracao_entry',
  },

  {
    week: 38,
    theme: 'Vibracao Endurance',
    theme_pt: 'Vibracao com Resistencia',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#7A5060',
    zone: 'Full floor 3-10cm', zone_pt: 'Assoalho completo 3-10cm',
    squeeze: { hold: 12, sets: 4, reps: 12 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    appNote: '10 seconds at Level 2, then 5 seconds at Level 3 per set.',
    appNote_pt: '10 segundos no Nivel 2, depois 5 segundos no Nivel 3 por serie.',
  },

  {
    week: 39,
    theme: 'Canal Lock',
    theme_pt: 'Bloqueio de Canal',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false,
    newMovement: 'Canal Lock', newMovement_pt: 'Bloqueio de Canal',
    freq: 5, color: '#7A5060',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    appNote: 'NEW: Canal Lock. Level 1 lateral and lift, Level 2, Level 3 compound. Full canal lock.',
    appNote_pt: 'NOVO: Bloqueio de Canal. Nivel 1 lateral e subida, Nivel 2, Nivel 3 composto. Bloqueio de canal completo.',
    primaryExercise: 'canal_lock_entry',
  },

  {
    week: 40,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 8, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null,
  },

  {
    week: 41,
    theme: 'Canal Lock at Speed',
    theme_pt: 'Bloqueio de Canal em Velocidade',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#7A5060',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    appNote: 'Canal Lock full sequence in under 10 seconds.',
    appNote_pt: 'Sequencia completa do Bloqueio de Canal em menos de 10 segundos.',
  },

  {
    week: 42,
    theme: 'Onda and Aperto Combined',
    theme_pt: 'Onda e Aperto Combinados',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#7A5060',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 15, sets: 4, reps: 12 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 5 },
    milestone: null,
    exercises: ['aperto_hold', 'onda_entry'],
    appNote: 'Run Aperto x10 first, then ride the Onda x8 without resetting. Pair them in the same set.',
    appNote_pt: 'Faca Aperto x10 primeiro e siga direto para a Onda x8 sem zerar. Combine os dois na mesma serie.',
  },

  {
    week: 43,
    theme: 'Deep Front Hold',
    theme_pt: 'Sustentacao Profunda Anterior',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#5A3848',
    zone: 'Front wall 6-10cm', zone_pt: 'Parede frontal 6-10cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    appNote: 'Succao held for 15 seconds at Level 3 anterior. Anterior push and 8-count return.',
    appNote_pt: 'Succao sustentada por 15 segundos no Nivel 3 anterior. Empurrar anterior e retorno em 8 tempos.',
  },

  {
    week: 44,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 10, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null,
  },

  {
    week: 45,
    theme: 'Circular (Clockwise)',
    theme_pt: 'Circular (Horario)',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false,
    newMovement: 'Circular', newMovement_pt: 'Circular',
    freq: 5, color: '#5A3848',
    zone: 'Full floor 0-3cm', zone_pt: 'Assoalho completo 0-3cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 5, reps: 8 },
    pushRule: 'direction_max_5s',
    milestone: null,
    appNote: 'NEW: Circular clockwise. Front-right, right, back-right, release. Full neutral between each step.',
    appNote_pt: 'NOVO: Circular horario. Frente-direita, direita, costas-direita, soltar. Neutro completo entre cada passo.',
    primaryExercise: 'circular_cw',
  },

  {
    week: 46,
    theme: 'Circular: Both Directions',
    theme_pt: 'Circular: Ambos os Sentidos',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 6, color: '#5A3848',
    zone: 'Full floor 0-6cm', zone_pt: 'Assoalho completo 0-6cm',
    squeeze: { hold: 15, sets: 5, reps: 12 },
    relax: { cycles: 10 },
    push: { hold: 5, reps: 8 },
    pushRule: 'direction_max_5s',
    milestone: null,
    exercises: ['circular_cw', 'circular_ccw'],
    appNote: 'Circular clockwise x10 reps, then counterclockwise x10 reps.',
    appNote_pt: 'Circular horario x10 rep, depois anti-horario x10 rep.',
  },

  {
    week: 47,
    theme: 'Rajada Lateral',
    theme_pt: 'Rajada Lateral',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false,
    newMovement: 'Rajada Lateral', newMovement_pt: 'Rajada Lateral',
    freq: 6, color: '#5A3848',
    zone: 'Side walls 0-3cm', zone_pt: 'Paredes laterais 0-3cm',
    squeeze: { hold: 10, sets: 6, reps: 40 },
    relax: { cycles: 8 },
    push: { hold: 10, reps: 3 },
    milestone: null,
    appNote: 'NEW: Rajada Lateral. Rapid Aperto at 1 second on, 1 second off, x40 reps x6 sets. Full lateral release between every set.',
    appNote_pt: 'NOVO: Rajada Lateral. Aperto rapido 1 segundo ativado, 1 segundo solto, x40 rep x6 series. Soltura lateral completa entre cada serie.',
    primaryExercise: 'rajada_lateral',
  },

  {
    week: 48,
    theme: 'Recovery: Peak Rest',
    theme_pt: 'Recuperacao: Descanso de Pico',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    squeeze: { hold: 10, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null,
  },

  {
    week: 49,
    theme: 'Full Year 1 Integration',
    theme_pt: 'Integracao Final Ano 1',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 6, color: '#5A3848',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 15, sets: 3, reps: 3 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 5 },
    milestone: null,
    exercises: ['pulsacao_entry', 'aperto_entry', 'ordenha_full', 'succao_entry', 'onda_entry', 'vibracao_entry', 'circular_cw'],
    appNote: 'Full sequence: Pulsacao, Aperto, Ordenha, Succao, Onda, Vibracao, Circular. Full RELAX between each named movement.',
    appNote_pt: 'Sequencia completa: Pulsacao, Aperto, Ordenha, Succao, Onda, Vibracao, Circular. RELAXAR completo entre cada movimento nomeado.',
  },

  {
    week: 50,
    theme: 'Full Integration at Depth',
    theme_pt: 'Integracao na Profundidade',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 6, color: '#5A3848',
    zone: 'Full floor 3-10cm', zone_pt: 'Assoalho completo 3-10cm',
    squeeze: { hold: 15, sets: 3, reps: 3 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 5 },
    milestone: null,
    exercises: ['pulsacao_l2', 'aperto_entry', 'ordenha_full', 'succao_entry', 'onda_entry', 'vibracao_entry', 'circular_cw'],
    appNote: 'Same sequence as Week 49. All movements at Level 2 minimum.',
    appNote_pt: 'Mesma sequencia da Semana 49. Todos os movimentos no Nivel 2 minimo.',
  },

  {
    week: 51,
    theme: 'Personal Assessment',
    theme_pt: 'Avaliacao Pessoal',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#5A3848',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 5 },
    milestone: null,
    appNote: 'Your 3 strongest movements. Best quality. This is your personal assessment session.',
    appNote_pt: 'Seus 3 movimentos mais fortes. Melhor qualidade. Esta e a sua sessao de avaliacao pessoal.',
  },

  {
    week: 52,
    theme: 'Year 2 Preview',
    theme_pt: 'Previa do Ano 2',
    phase: 'Advanced', phase_pt: 'Avancado',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#5A3848',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    squeeze: { hold: 15, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 5 },
    milestone: null,
    appNote: 'Your body now understands itself. Year 2 begins.',
    appNote_pt: 'Seu corpo agora se entende. O Ano 2 comeca.',
    year2Preview: true,
  },

]
